export const FooterData = [
  {
    title: "Get in touch",
    data: [
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/inesita/",
        external: true,
      },
      {
        name: "Instagram",
        url: "https://www.instagram.com/inesdlcroix/",
        external: true,
      },
      {
        name: "E-mail me!",
        url: "mailto:ines.imaginethefuture@gmail.com",
        external: true,
      },
    ],
  },
  {
    title: "About",
    data: [
      {
        name: "Services",
        url: "/services",
        external: false,
      },
      {
        name: "Coach’s Notebook",
        url: "/coach's-Notebook",
        external: false,
      },
    ],
  },
];
